export interface User {
    id: number;
    email: string;
    number: number;
    mobilePhone: string;
    name: string;
    surname: string;
    role: AuthRole;
    adminRole?: EAdminRole;
    dispatcher_id?: number;
}

export enum AuthRole {
    USER = 'user',
    DISPATCHER = 'dispatcher',
    ATTACHMENT_UPLOAD = 'attachment_upload',
    ONBOARDING = 'onboarding',
}
export enum EAdminRole {
    ADMIN = "ADMIN",
    EMPLOYEE = "EMPLOYEE",
}

export interface AuthState {
    isAuthenticated: boolean | null;
    user: User | null;
    token: string | null;
}

export interface LoginError extends Error {
    message: string;
}

export interface SignupError extends Error {
    errors: {
        message: string;
        extensions: {
            code: 'RECORD_NOT_UNIQUE' | string;
            field: 'email' | string;
        };
    }[];
}

export interface RequestResetPasswordError extends Error {
    errors: {
        message: string;
        extensions: {
            code: 'INVALID_PAYLOAD' | 'FORBIDDEN' | string;
        };
    }[];
}

export interface AuthToken {
    email: string;
    emailPassword: string;
    exp: number;
    iat: number;
    jobTitle: string;
    mobilePhone: string;
    number: number;
    name: string;
    surname: string;
    role: AuthRole;
    adminRole?: EAdminRole;
    user_id: number;
    dispatcher_id?: number;
}

export type TAttachmentUploadTokenPayload = {
    role: AuthRole.ATTACHMENT_UPLOAD;
    commissionId: number;
    commissionQId: string | null;
    exp: number;
    iat: number;
};
